<template>
  <div>
    <b-link v-b-modal.show-workbook-data>
      {{ $t('Workbook') }}
    </b-link>
    <b-modal
      id="show-workbook-data"
      :title="$t('Workbook')"
      hide-footer
      size="lg"
    >
      <b-table
        ref="examTable"
        :items="workbooks"
        responsive
        :fields="fields"
        primary-key="id"
        show-empty
        :empty-text="$t('No matching records found')"
        class="position-relative"
      >
        <template #head()="data">
          {{ $t(data.label) }}
        </template>

        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell(end_date)="data">
          {{ data.value ? data.value : $t('Until now') }}
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">

          <div class="text-nowrap">
            <feather-icon
              v-b-toggle.sidebar-create-exam
              icon="EyeIcon"
              class="cursor-pointer mr-1"
              size="16"
              @click="$router.push({ name: 'exam-view', params: { id: data.item.id }})"
            />
          </div>
        </template>

      </b-table>

    </b-modal>
  </div>
</template>

<script>
import { VBModal, BLink, BTable } from 'bootstrap-vue'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BLink,
    BTable,
  },
  props: {
    workbooks: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      default: () => [
        { key: 'index', label: '#' },
        { key: 'company_name', label: 'Company name', sortable: true },
        { key: 'position_name', label: 'Position', sortable: true },
        { key: 'start_date', label: 'Start date', sortable: true },
        { key: 'end_date', label: 'End data', sortable: true },
      ],
    },
  },
}
</script>

<style scoped>

</style>
